import React from 'react';
import { Box, Typography } from '@mui/material';

interface FocalPointPickerProps {
  imageUrl: string;
  value: string; // "x% y%"
  onChange: (position: string) => void;
}

const FocalPointPicker: React.FC<FocalPointPickerProps> = ({ imageUrl, value, onChange }) => {
  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = Math.round(((e.clientX - rect.left) / rect.width) * 100);
    const y = Math.round(((e.clientY - rect.top) / rect.height) * 100);
    onChange(`${x}% ${y}%`);
  };

  const parts = (value || '50% 50%').split(' ');
  const px = parseFloat(parts[0]) || 50;
  const py = parseFloat(parts[1]) || 50;

  return (
    <Box>
      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.75 }}>
        Click to set the focal point — this is where the image is anchored in the 16:9 display.
      </Typography>
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          aspectRatio: '16/9',
          overflow: 'hidden',
          borderRadius: 1,
          cursor: 'crosshair',
          border: '2px solid',
          borderColor: 'primary.main',
        }}
        onClick={handleClick}
      >
        <Box
          component="img"
          src={imageUrl}
          alt="Focal point preview"
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            objectPosition: value || '50% 50%',
            pointerEvents: 'none',
            userSelect: 'none',
            display: 'block',
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            left: `${px}%`,
            top: `${py}%`,
            transform: 'translate(-50%, -50%)',
            width: 20,
            height: 20,
            borderRadius: '50%',
            border: '2px solid white',
            boxShadow: '0 0 0 2px rgba(0,0,0,0.6)',
            pointerEvents: 'none',
          }}
        />
      </Box>
    </Box>
  );
};

export default FocalPointPicker;
